import _ from "lodash";
import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import SubMenuCurriculumWrapper from "Administrator/commonComponents/SubMenuCurriculumWrapper";
import { getNextMenuRoute } from "Administrator/modules/AdministratorModule";
import { getRelativePath } from "Utils";
export default store => ({
  path: "grades",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-schoolSetup" */ "./components"),
        import(
          /* webpackChunkName: "admin-schoolSetup" */ "./modules/GradesModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "gradesSetup",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter(nextState, replace) {
    if (_.last(nextState.routes).path == "grades") {
      const route = getNextMenuRoute("GRADES_SETUP");
      if (route) {
        replace(getRelativePath(route));
      } else {
        replace(getRelativePath("../"));
      }
    }
  },
  childRoutes: [SubMenuCurriculumWrapper(store)],
});
